import { QueryState } from 'src/app/core/models/query.model';
import { createTokenQueryServiceInstance } from 'src/app/core/services/query.service';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { IPrelievo, getStatusIcon, getParametriDatiPrelievoFk, getDefDatiPrelievoFk, getValDatiPrelievoFk, getSiNo, getDescrAzioneCorrettiva, getStatiPrelievoFk } from './models/prelievo.model';
import { IParametriAlert } from './models/parametri-alert';
import { ParametriObblMancanti } from './models/parametri-obbligatori-mancanti.model';
import { ITableColumn } from 'src/app/core/models/table.model';
import { Reportnet3 } from './models/reportnet3';


export const REPORTNET3_ENDPOINT = 'get-all-superamenti-reportnet3-ges';
export const REPORTNET_ENDPOINT_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(REPORTNET3_ENDPOINT);

export const PRELIEVO_EX_ENDPOINT = 'controlli';
export const PRELIEVO_EX_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(PRELIEVO_EX_ENDPOINT);

export const PRELIEVO_ENDPOINT = 'controlli-grouped';
export const PRELIEVO_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(PRELIEVO_ENDPOINT);

export const PARAMETRI_OBBLIGATORI_ENDPOINT = 'controllo/parametri-obbligatori-mancanti';
export const PARAMETRI_OBBLIGATORI_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(PARAMETRI_OBBLIGATORI_ENDPOINT);

export const PARAMETRI_ALERT_ENDPOINT = 'controllo/parametri-alert';
export const PARAMETRI_ALERT_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(PARAMETRI_ALERT_ENDPOINT);

export const prelievoStateConfig: SignalStoreConfig<QueryState<IPrelievo>> = {
  initState: {
    list: [],
    // sort: {
    //   field: 'dataPrelievo',
    //   direction: 'asc'
    // }
  }
}

export const reportnetListaStateConfig: SignalStoreConfig<QueryState<Reportnet3>> = {
  initState: {
    list: [],
    /*
    sort: {
      field: 'uuid',
      direction: 'asc'
    } */
  }
}

export const TRASMISSIONE_REPORTNET_COLUMNS: ITableColumn[] = [
  {
    name: 'uuid',
    label: 'UUID',
    field: 'uuid'
  },
  {
    name: 'istatComune',
    label: 'Comune',
    field: 'istatComune'
  },
  {
    name: 'dataOraPrelievo',
    label: 'Data Ora Prelievo',
    field: 'dataOraPrelievo',
    type: 'datetime'
  },
  {
    name: 'parametro',
    label: 'Parametro',
    field: 'parametro'
  },
  {
    name: 'valore',
    label: 'Valore',
    field: 'valore'
  },
  {
    name: 'superamento',
    label: 'Superamento',
    field: 'superamento',
    cell: (row: Reportnet3) => getSiNo(row.superamento)
  },
  {
    name: 'superamentoNonSignificativo',
    label: 'Superamento Non Significativo',
    field: 'superamentoNonSignificativo',
    cell: (row: Reportnet3) => getSiNo(row.superamentoNonSignificativo)
  }
];

export const TRASMISSIONEREPORTNET_VISIBLECOLUMNS = [
  'uuid',
  'istatComune',
  'dataOraPrelievo',
  'parametro',
  'valore',
  'superamento',
  'superamentoNonSignificativo'
];

export const statusDefaultIcon: { [key: string]: string } = {
  'ok': 'done',
  'warning': 'warning',
  'alert': 'error'
}

export const statusDefaultTextColor: { [key: string]: string } = {
  'ok': 'text-green-400',
  'warning': 'text-yellow-400',
  'alert': 'text-red-400'
}

export const CONTROLLI_COLUMNS: ITableColumn[] = [
  {
    name: 'id',
    label: 'ID',
    field: 'idControlli',
    primaryKey: true,
    visible: false,
  },
  {
    name: 'puntoCampionamentoUuid',
    label: 'Punto di Campionamento',
    field: 'uuid',
    cell: (element: IPrelievo) => element.uuid,
  },
  {
    name: 'dataOraPrelievo',
    label: 'Data e ora Prelievo',
    field: 'dataOraPrelievo',
    type: 'datetime',
  },
 
];
export const CONTROLLI_DETTAGLIO_COLUMNS: ITableColumn[] = [
  {
    name: 'id',
    label: 'ID',
    field: 'id',
    primaryKey: true,
    visible: false
  },
  {
    name: 'puntoCampionamentoUuid',
    label: 'Punto di Campionamento',
    field: 'uuid',
    cell: (element: IPrelievo) => element.uuid,
  },
  {
    name: 'dataOraPrelievo',
    label: 'Data e ora Prelievo',
    field: 'dataOraPrelievo',
    type: 'datetime',
  },
   {
    name: 'codicePrelievo',
    label: 'Codice Prelievo',
    field: 'codicePrelievo'
  },
  {
    name: 'entePrelievo',
    label: 'Ente Prelievo',
    field: 'entePrelievo'
  },
  {
    name: 'numeroRapportoProvaAnalisi',
    label: 'N° Rapporto di prova Analisi',
    field: 'numeroRapportoProvaAnalisi'
  },
  {
    name: 'dataOraAnalisi',
    label: 'Data e ora Analisi',
    field: 'dataOraAnalisi',
    type: 'datetime',
  },
  {
    name: 'codiceAccrediaLab',
    label: 'Cod. Accredia lab. Analisi',
    field: 'codiceAccrediaLab'
  },
  {
    name: 'status',
    label: 'Status',
    field: 'status',
    classes: { 'pl-4': true },
    cell: (element: IPrelievo) => getStatusIcon(element.status)
  }
];

export const PARAMETRI_OBBL_MANCANTI_COLUMNS: ITableColumn[] = [
  {
    name: 'id',
    label: 'ID',
    field: 'id',
    primaryKey: true,
    visible: false,
  },
  {
    name: 'definizione',
    label: 'Definizione',
    field: 'definizione',
  },
  {
    name: 'unitaDiMisura',
    label: 'Unità di Misura',
    field: 'unitaDiMisura',
  },
  {
    name: 'precisioneMinima',
    label: 'Precisione Minima',
    field: 'precisioneMinima',
  },
  {
    name: 'note',
    label: 'Note',
    field: 'note',
  },
  {
    name: 'obbligatorio',
    label: 'Obbligatorio',
    field: 'obbligatorio',
  },

];
export const PARAMETRI_ALERT_COLUMNS: ITableColumn[] = [
  {
    name: 'id',
    label: 'ID',
    field: 'datiPrelievoId',
    primaryKey: true,
    visible: false,
    cell: (element: IParametriAlert) => element.parametro.id,
  },
  {
    name: 'definizione',
    label: 'Definizione',
    field: 'definizione',
    cell: (element: IParametriAlert) => element.parametro.definizione,
  },
  {
    name: 'minimo',
    label: 'Minimo',
    field: 'minimo',
  },
  {
    name: 'massimo',
    label: 'Massimo',
    field: 'massimo',
  },
  {
    name: 'unitaDiMisura',
    label: 'Unità di Misura',
    field: 'unitaDiMisura',
    cell: (element: IParametriAlert) => element.parametro.unitaDiMisura,
  },
  {
    name: 'precisioneMinima',
    label: 'Precisione Minima',
    field: 'precisioneMinima',
    cell: (element: IParametriAlert) => element.parametro.precisioneMinima,
  },
  {
    name: 'note',
    label: 'Note',
    field: 'note',
    cell: (element: IParametriAlert) => element.parametro.note,
  },
  {
    name: 'obbligatorio',
    label: 'Obbligatorio',
    field: 'obbligatorio',
    cell: (element: IParametriAlert) => element.parametro.obbligatorio ? 'SI' : 'NO',
  },
  {
    name: 'valore',
    label: 'Valore',
    field: 'valore',
  },
];